// extracted by mini-css-extract-plugin
export default {"menuItem":"SwippyMenuItem_menuItem__JAHsY","active":"SwippyMenuItem_active__TcaI1","label":"SwippyMenuItem_label__euziP"};